import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import AuthAppLayout from '../components/auth/oauth/AuthAppLayout';
import AuthAppResultLayout from '../components/auth/oauth/AuthAppResultLayout';
import ForgotPassword from '../components/auth/oauth/ForgotPassword';

const OAuthLayout = ({location}) => {
    return(
        <Switch>
            <Route path={`${process.env.PUBLIC_URL}/oauth/authapp`} exact component={AuthAppLayout} />
            <Route path={`${process.env.PUBLIC_URL}/oauth/authappresult`} exact component={AuthAppResultLayout} />
            <Route path={`${process.env.PUBLIC_URL}/oauth/forgotpassword`} exact component={ForgotPassword}/>

            <Redirect to={`${process.env.PUBLIC_URL}/errors/404`} />
        </Switch>
    )
}

export default OAuthLayout;